<div class="relative z-[2]">
  <ri-resolution-ui-header></ri-resolution-ui-header>
</div>
